import { useQuery } from "@tanstack/react-query";
import api from "../lib/api";
import { parseDeliveryConfig } from "../lib/catalog";

export function useDelivery() {
  const { data } = useQuery({ queryKey: ["stores"], queryFn: api.getStores });
  const cfg = parseDeliveryConfig(data);
  const isFreePeriod = cfg.freeUntil ? Date.now() <= new Date(cfg.freeUntil + "T23:59:59").getTime() : false;
  const feeFor = (subtotal) => (isFreePeriod || Number(subtotal) >= cfg.freeOver ? 0 : cfg.fee);
  return { baseFee: cfg.fee, freeOver: cfg.freeOver, freeUntil: cfg.freeUntil, isFreePeriod, feeFor, configStoreId: cfg.storeId };
}
